import React, {useCallback, useEffect, useState} from "react";
import style from "../../assets/css/checkout.module.scss";
import {Box, Grid} from "@mui/system";
import GlobalTextField from "../global-fields/GlobalTextField";
import {
  Button,
  ButtonGroup,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import GlobalRadio from "../global-fields/GlobalRadio";
import CardNox from "../../assets/img/icons/cardnox.svg";
import Cheque from "../../assets/img/icons/cheque.svg";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import styled from "styled-components";
import {BsFillCreditCard2FrontFill} from "react-icons/bs";
import {FaMoneyCheckAlt} from "react-icons/fa";
import {MdDeleteForever, MdOutlineGppGood} from "react-icons/md";
import {FaEye} from "react-icons/fa";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import * as Yup from "yup";
import GlobalSelectField from "../global-fields/GlobalSelectField";
import {selectUiState, setUiData} from "../../store/uiSlice";
import {GET_EMI_DETAILS, PAYMENT} from "../../constants/apiConstant";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
import {selectDataStoreState, setDataStore} from "../../store/dataSlice";
import {useDispatch, useSelector} from "react-redux";
import {selectAuthState} from "../../store/authSlice";
import {useNavigate} from "react-router-dom";
import {useFormik} from "formik";
import {
  parseToNumber,
  removeCookies,
  USD_FORMATTER,
} from "../../constants/helper";
import {ERR_MESSAGE} from "../../constants/constants";
import GlobalCheckBox from "../global-fields/GlobalCheckBox";
import GlobalErrorMsgBox from "../global-fields/GlobalErrorMsgBox";
import GlobalModal from "../global-fields/GlobalModal";
import PaymentSuccess from "../../assets/img/icons/payment-success.png";
import PaymentFail from "../../assets/img/icons/payment-fail.png";
import {
  cardNumberSchema,
  chequeNumberSchema,
  numberSchema,
} from "../../constants/validationSchemas";

const BootstrapDialog = styled(Dialog)(({theme}) => ({}));

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const CurrentYear = new Date().getFullYear();

const MonthsMenuItems = Array.from({length: 12}, (_, ind) => ({
  name: ind + 1,
  value: ind + 1,
}));

const YearMenuItems = Array.from({length: 50}, (_, ind) => ({
  name: CurrentYear + ind,
  value: CurrentYear + ind,
}));

const Checkout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user} = useSelector(selectAuthState);
  const {cardnoxModal} = useSelector(selectUiState);
  const {checkoutData, EMIDetails, checkoutRawData} =
    useSelector(selectDataStoreState);
  const [open, setOpen] = useState(false);
  const [paymentId, setPaymentId] = useState(1);
  const [partialPayment, setPartialPayment] = useState(false);
  const [processingFee, setProcessingFee] = useState(false);
  const [autoDebit, setAutoDebit] = useState(true);
  const [selectedEmi, setSelectedEmi] = useState(null);
  const [paymentStatusModal, setPaymentStatusModal] = useState(false);
  const [paymentStatusData, setPaymentStatusData] = useState(null);
  // console.log("checkoutData", checkoutData, checkoutRawData);

  const fetchEmiDetails = async () => {
    if (checkoutData?.exhibition_id || checkoutData?.endorsement_id) {
      return;
    }
    dispatch(setUiData({showLoader: true}));
    const data = {
      user_id: user?.id,
      proposal_id: checkoutData?.proposal_id,
    };
    try {
      const response = await fetch(GET_EMI_DETAILS.url, {
        method: GET_EMI_DETAILS.method,
        headers: GET_EMI_DETAILS.headers,
        body: JSON.stringify(data),
      });

      const res = await response.json();

      dispatch(setUiData({showLoader: false}));

      if (res.status == 1) {
        dispatch(setDataStore({EMIDetails: res.data}));
      } else {
        GlobalNotificationPopup({type: "error", message: res?.message});
      }
    } catch (error) {
      console.error("Error:", error);
      removeCookies("isLogin");
      dispatch(setUiData({showLoader: false}));
      GlobalNotificationPopup({
        type: "error",
        message: ERR_MESSAGE,
      });
      navigate("/");
    }
  };

  useEffect(() => {
    if (checkoutData) {
      fetchEmiDetails();
    }
  }, [checkoutData]);

  const [imagePopup, setImagePopup] = useState(null);
  const handleClickOpen = (field) => {
    const file = chequeFormik.values[field];

    if (!file) {
      GlobalNotificationPopup({
        type: "warning",
        message: "Upload Image First.",
      });
      return;
    }

    setImagePopup({
      type: field,
      img: file,
      img_preview: URL.createObjectURL(file),
      image_raw: file,
    });

    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseChequeImage = (field) => {
    // console.log("field", field);
    //return
    chequeFormik.setFieldValue(field, "");
    setOpen(false);
  };
  const handlePaymentMethod = (id) => {
    setPaymentId(id);
  };

  const creditDebitCardInitialValues = {
    payment_id: 1,
    card_name: "",
    card_number: "",
    card_exp_month: "",
    card_exp_year: "",
    cvv: "",
  };

  const creditDebitCardFormik = useFormik({
    initialValues: creditDebitCardInitialValues,
    validationSchema: Yup.object({
      card_name: Yup.string().required("Card name is required"),
      card_number: cardNumberSchema,
      card_exp_month: Yup.number()
        .typeError("Must be a number")
        .min(1, "Invalid month")
        .max(12, "Invalid month")
        .required("Month is required"),
      card_exp_year: Yup.number()
        .typeError("Must be a number")
        .min(CurrentYear, "Invalid year")
        .required("Year is required"),
      cvv: numberSchema
        .matches(/^\d{3,4}$/, "CVV must be 3 or 4 digits")
        .required("CVV is required"),
    }),
    onSubmit: async (values, {resetForm}) => {
      submitCheckout(values, resetForm, 1);
    },
  });

  const chequeInitialValues = {
    payment_id: 2,
    amount: checkoutData?.formated_hard_quote ?? "",
    // ? USD_FORMATTER.format(checkoutData?.formated_hard_quote)
    // : "",
    cheque_number: "",
    cheque_img_front: "",
    cheque_img_back: "",
  };
  const chequeFormik = useFormik({
    initialValues: chequeInitialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      amount: Yup.string().required("Amount is required"),
      cheque_number: chequeNumberSchema,
      cheque_img_front: Yup.mixed()
        .required("Front image is required")
        .test(
          "fileType",
          "Unsupported File Format",
          (value) =>
            value &&
            ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
        ),
      cheque_img_back: Yup.mixed()
        .required("Back image is required")
        .test(
          "fileType",
          "Unsupported File Format",
          (value) =>
            value &&
            ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
        ),
    }),
    onSubmit: async (values, {resetForm}) => {
      submitCheckout(values, resetForm, 2);
    },
  });

  const submitCheckout = useCallback(
    async (values, resetForm, payment_id) => {
      if (paymentId == 1 && !processingFee) {
        GlobalNotificationPopup({
          type: "error",
          message: "Please Agree Proccessing Fees First.",
        });
        return;
      }

      if (partialPayment && selectedEmi === null) {
        GlobalNotificationPopup({
          type: "error",
          message: "Please Select Preffered Tenure First.",
        });
        return;
      }
      const baseData = {
        ...values,
        user_id: user?.id,
        ...(checkoutData?.endorsement_id
          ? {endorsement_id: checkoutData?.id_forAPI ?? ""}
          : checkoutData?.exhibition_id
            ? {exhibition_id: checkoutData?.id_forAPI ?? ""}
            : {proposal_id: checkoutData?.proposal_id}),
        payment_mode: checkoutData?.id_forAPI
          ? "FULL_PAID"
          : !partialPayment && payment_id === 1
            ? "FULL_PAID"
            : payment_id === 1
              ? "EMI"
              : "CHEQUE",
        auto_debt: autoDebit ? 1 : 0,
        emi_frequency: selectedEmi?.type ?? "",
      };

      // console.log("REQUEST OPTIONS", baseData)

      let requestOptions = {
        method: PAYMENT.method,
        headers: PAYMENT.headers,
      };

      if (payment_id === 2) {
        // Convert to FormData
        const formData = new FormData();
        for (const key in baseData) {
          if (key === "cheque_img_front" || key === "cheque_img_back") {
            if (baseData[key]) {
              formData.append(key, baseData[key]);
            }
          } else {
            formData.append(key, baseData[key]);
          }
        }

        requestOptions.body = formData;

        // Remove 'Content-Type' so browser sets it to multipart/form-data
        if (requestOptions.headers && requestOptions.headers["Content-Type"]) {
          delete requestOptions.headers["Content-Type"];
        }
      } else {
        requestOptions.body = JSON.stringify(baseData);
      }

      // if (payment_id === 2 && requestOptions.body instanceof FormData) {
      //   console.log("---- FormData Content ----");
      //   for (let pair of requestOptions.body.entries()) {
      //     console.log(`${pair[0]}:`, pair[1]);
      //   }
      // }
      // return;
      dispatch(setUiData({showLoader: true}));

      try {
        const response = await fetch(PAYMENT.url, requestOptions);

        const res = await response.json();

        dispatch(setUiData({showLoader: false}));
        // console.log("Payment res Details:", res);

        // setPaymentStatusData(res);
        // setPaymentStatusModal(true);

        if (res.status === 1) {
          // GlobalNotificationPopup({ type: "success", message: res?.message });
          dispatch(
            setDataStore({
              EMIDetails: null,
              checkoutData: null,
              checkoutRawData: null,
            })
          );
          resetForm();
        } else {
          setPaymentStatusData(res);
          setPaymentStatusModal(true);
          dispatch(
            setDataStore({
              EMIDetails: null,
              checkoutData: null,
              checkoutRawData: null,
            })
          );
          // GlobalNotificationPopup({ type: "error", message: res?.message });
        }
      } catch (error) {
        console.error("Error:", error);
        removeCookies("isLogin");
        dispatch(setUiData({showLoader: false}));
        GlobalNotificationPopup({
          type: "error",
          message: ERR_MESSAGE,
        });
        dispatch(
          setDataStore({
            EMIDetails: null,
            checkoutData: null,
            checkoutRawData: null,
          })
        );
        navigate("/");
      }
    },
    [
      dispatch,
      user?.id,
      checkoutData,
      navigate,
      autoDebit,
      selectedEmi,
      partialPayment,
      processingFee,
      paymentId,
    ]
  );
  const handleAmountFieldChange = (e, fieldName) => {
    const rawValue = e.target.value;
    const numericValue = parseToNumber(rawValue);
    chequeFormik.setFieldValue(
      fieldName,
      numericValue !== "" ? USD_FORMATTER.format(numericValue) : ""
    );
  };
  const handlePaymentModalClose = () => {
    dispatch(
      setDataStore({
        EMIDetails: null,
        checkoutData: null,
        checkoutRawData: null,
      })
    );
    // setPaymentStatusModal(false);
    // setPaymentStatusData(null);
  };
  // console.log("user", checkoutData, user)
  // console.log("chequeFormik.values?.cheque_img_front ", chequeFormik.values);

  const CountdownRedirect = ({seconds = 10, onComplete}) => {
    const [timeLeft, setTimeLeft] = useState(seconds);

    useEffect(() => {
      if (timeLeft <= 0) {
        onComplete();
        return;
      }

      const timerId = setTimeout(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);

      return () => clearTimeout(timerId);
    }, [timeLeft, onComplete]);

    return (
      <small style={{display: "block", marginTop: "5px", color: "#666"}}>
        Redirecting to dashboard in {timeLeft} second{timeLeft !== 1 ? "s" : ""}
        ...
      </small>
    );
  };
  console.log(user);

  return (
    <>
      <section className={style.CheckoutSection}>
        <Grid container spacing={2} className="customeContainer">
          <Grid size={{xs: 12, lg: 12}}>
            <div className={style.CheckoutTitle}>
              <h2>Checkout</h2>
            </div>
          </Grid>
          <Grid size={{xs: 12, lg: 5}}>
            <div className={style.CheckoutDetails}>
              <h2>Client Details</h2>
              <ul>
                <li>
                  <p>Name</p>
                  <p>
                    {user?.first_name} {user?.last_name}
                  </p>
                </li>
                {
                  <li>
                    <p>Company Name</p>
                    <p>{checkoutData?.firm_name}</p>
                  </li>
                }
                <li>
                  <p>Contact Number</p>
                  <p>{user?.mobile_no}</p>
                </li>
                <li>
                  <p>Email</p>
                  <p>{user?.email}</p>
                </li>
              </ul>
            </div>
            <div className={style.CheckoutDetails}>
              <h2>Proposal Details</h2>
              <ul>
                <li>
                  <p>Proposal Number</p>
                  <p> {checkoutData?.proposal_id} </p>
                </li>

                {checkoutData?.endorsement_id ? (
                  <li>
                    <p>Endorsement ID</p>
                    <p> {checkoutData?.endorsement_id} </p>
                  </li>
                ) : null}

                {checkoutData?.exhibition_id ? (
                  <li>
                    <p>Exhibition ID</p>
                    <p> {checkoutData?.exhibition_id} </p>
                  </li>
                ) : null}
                <li>
                  <p>Date</p>
                  <p> {checkoutData?.proposal_date} </p>
                </li>
                {/* <li>
                  <p>Date To</p>
                  <p> 25 March, 2026 </p>
                </li> */}
                <li>
                  <p>Amount</p>
                  <p>
                    {processingFee && paymentId == 1
                      ? checkoutData?.formated_hard_quote_with_Fee
                      : checkoutData?.formated_hard_quote}{" "}
                  </p>
                </li>
              </ul>
            </div>
          </Grid>

          <Grid size={{xs: 12, lg: 7}}>
            <div className={style.CheckoutForm}>
              <h2>Total Amount</h2>
              <div className={style.amountText}>
                <p></p>
                <h3>
                  {processingFee
                    ? checkoutData?.formated_hard_quote_with_Fee
                    : checkoutData?.formated_hard_quote}{" "}
                </h3>
              </div>
              <Box className={style.CheckOutTabs}>
                <Button
                  variant="outlined"
                  type="button"
                  onClick={() => {
                    handlePaymentMethod(1);
                    setPartialPayment(false);
                    setProcessingFee(false);
                    setAutoDebit(false);
                    setSelectedEmi(null);
                    //if (chequeFormik.values.cheque_number === "") {
                    chequeFormik.resetForm();
                    //}
                  }}
                  className={paymentId == 1 ? style.active : {}}
                >
                  <BsFillCreditCard2FrontFill /> <span>Credit/Debit</span>
                </Button>
                {checkoutData?.exhibition_id ||
                checkoutData?.endorsement_id ? null : (
                  <Button
                    variant="outlined"
                    type="button"
                    onClick={() => {
                      handlePaymentMethod(2);
                      setPartialPayment(false);
                      setProcessingFee(false);
                      setAutoDebit(false);
                      setSelectedEmi(null);
                      //if (creditDebitCardFormik.values.card_number !== "") {
                      creditDebitCardFormik.resetForm();
                      //}
                    }}
                    className={paymentId == 2 ? style.active : {}}
                  >
                    <FaMoneyCheckAlt /> <span>Cheque</span>
                  </Button>
                )}
              </Box>

              {/* Credit / debit content div */}
              {paymentId == 1 ? (
                <form
                  onSubmit={creditDebitCardFormik.handleSubmit}
                  autoComplete="false"
                  autoSave="false"
                >
                  <Grid container spacing={2}>
                    <Grid size={{xs: 12, lg: 6, sm: 6}}>
                      <FormControl fullWidth>
                        <FormLabel
                          sx={{mb: 1, textAlign: "left", color: "#000000"}}
                        >
                          Card Name
                        </FormLabel>
                      </FormControl>
                      <GlobalTextField
                        type="text"
                        name="card_name"
                        id="_card_name"
                        value={creditDebitCardFormik.values.card_name}
                        onChange={creditDebitCardFormik.handleChange}
                        onBlur={creditDebitCardFormik.handleBlur}
                        error={
                          creditDebitCardFormik.touched.card_name &&
                          Boolean(creditDebitCardFormik.errors.card_name)
                        }
                        helperText={
                          creditDebitCardFormik.touched.card_name &&
                          creditDebitCardFormik.errors.card_name
                        }
                      />
                    </Grid>
                    <Grid size={{xs: 12, lg: 6, sm: 6}}>
                      <FormControl fullWidth>
                        <FormLabel
                          sx={{mb: 1, textAlign: "left", color: "#000000"}}
                        >
                          Card Number
                        </FormLabel>
                      </FormControl>
                      <GlobalTextField
                        type="text"
                        name="card_number"
                        id="_card_number"
                        value={creditDebitCardFormik.values.card_number}
                        onChange={creditDebitCardFormik.handleChange}
                        onBlur={creditDebitCardFormik.handleBlur}
                        error={
                          creditDebitCardFormik.touched.card_number &&
                          Boolean(creditDebitCardFormik.errors.card_number)
                        }
                        helperText={
                          creditDebitCardFormik.touched.card_number &&
                          creditDebitCardFormik.errors.card_number
                        }
                      />
                    </Grid>
                    <Grid size={{xs: 12, xl: 4, lg: 4, sm: 4}} sx={{mt: 1}}>
                      <FormControl fullWidth>
                        <FormLabel
                          sx={{mb: 1, textAlign: "left", color: "#000000"}}
                        >
                          Expiry Month
                        </FormLabel>
                      </FormControl>
                      <GlobalSelectField
                        value={creditDebitCardFormik.values.card_exp_month}
                        onChange={(e) =>
                          creditDebitCardFormik.setFieldValue(
                            "card_exp_month",
                            e.target.value
                          )
                        }
                        onBlur={creditDebitCardFormik.handleBlur}
                        error={
                          creditDebitCardFormik.touched.card_exp_month &&
                          Boolean(creditDebitCardFormik.errors.card_exp_month)
                        }
                        helperText={
                          creditDebitCardFormik.touched.card_exp_month &&
                          creditDebitCardFormik.errors.card_exp_month
                        }
                        placeH="Select"
                        menuItems={MonthsMenuItems}
                      />
                    </Grid>
                    <Grid size={{xs: 12, xl: 4, lg: 4, sm: 4}} sx={{mt: 1}}>
                      <FormControl fullWidth>
                        <FormLabel
                          sx={{mb: 1, textAlign: "left", color: "#000000"}}
                        >
                          Expiry Year
                        </FormLabel>
                      </FormControl>
                      <GlobalSelectField
                        value={creditDebitCardFormik.values.card_exp_year}
                        onChange={(e) =>
                          creditDebitCardFormik.setFieldValue(
                            "card_exp_year",
                            e.target.value
                          )
                        }
                        onBlur={creditDebitCardFormik.handleBlur}
                        error={
                          creditDebitCardFormik.touched.card_exp_year &&
                          Boolean(creditDebitCardFormik.errors.card_exp_year)
                        }
                        helperText={
                          creditDebitCardFormik.touched.card_exp_year &&
                          creditDebitCardFormik.errors.card_exp_year
                        }
                        placeH="Select"
                        menuItems={YearMenuItems}
                      />
                    </Grid>
                    <Grid size={{xs: 12, xl: 4, lg: 4, sm: 4}} sx={{mt: 1}}>
                      <FormControl fullWidth>
                        <FormLabel
                          sx={{mb: 1, textAlign: "left", color: "#000000"}}
                        >
                          CVV
                        </FormLabel>
                      </FormControl>
                      <GlobalTextField
                        type="text"
                        name="cvv"
                        id="_cvv"
                        value={creditDebitCardFormik.values.cvv}
                        onChange={creditDebitCardFormik.handleChange}
                        onBlur={creditDebitCardFormik.handleBlur}
                        error={
                          creditDebitCardFormik.touched.cvv &&
                          Boolean(creditDebitCardFormik.errors.cvv)
                        }
                        helperText={
                          creditDebitCardFormik.touched.cvv &&
                          creditDebitCardFormik.errors.cvv
                        }
                      />
                    </Grid>

                    <Box className={style.partialPaymentText} sx={{mt: 1}}>
                      <FormControl
                        component="fieldset"
                        variant="standard"
                        className="checkoutCheckBox"
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={processingFee}
                              name="Convert the amount into partial payments."
                              onChange={(e) => {
                                setProcessingFee(!processingFee);
                                if (e.target.checked === false) {
                                  setSelectedEmi(null);
                                  setAutoDebit(false);
                                }
                              }}
                            />
                          }
                          label="I hereby authorize a non-refundable 3% credit card processing fee to be added to my total, as part of my payment by credit card."
                        />
                      </FormControl>
                    </Box>

                    {checkoutData?.endorsement_id ||
                    checkoutData?.exhibition_id ? null : (
                      <Box className={style.partialPaymentText}>
                        <FormControl
                          component="fieldset"
                          variant="standard"
                          className="checkoutCheckBox"
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={partialPayment}
                                name="Convert the amount into partial payments."
                                onChange={(e) => {
                                  setPartialPayment(!partialPayment);
                                  if (e.target.checked === false) {
                                    setSelectedEmi(null);
                                    setAutoDebit(false);
                                  }
                                }}
                              />
                            }
                            label="Convert the amount into partial payments."
                          />
                        </FormControl>
                      </Box>
                    )}

                    {partialPayment && EMIDetails?.length ? (
                      <>
                        <Grid size={{xs: 12}}>
                          <FormControl fullWidth>
                            <FormLabel sx={{textAlign: "left", color: "#000"}}>
                              Select Preferred Tenure
                            </FormLabel>
                          </FormControl>
                        </Grid>

                        {EMIDetails?.map((emi) => {
                          return (
                            <>
                              <Grid
                                size={{xs: 12, xl: 4, lg: 6, md: 6, sm: 6}}
                                sx={{mb: 3}}
                                //className={style.checkoutRadio}
                              >
                                <Box
                                  onClick={() => {
                                    setSelectedEmi(emi);
                                  }}
                                  elevation={3}
                                  sx={{
                                    p: 3,
                                    pb: 0,
                                    opacity:
                                      emi?.type === selectedEmi?.type ? 1 : 0.7,
                                    borderRadius: 3,
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    backgroundColor:
                                      emi?.type === selectedEmi?.type
                                        ? "#DAF4FF"
                                        : "#fff",
                                    cursor: "pointer",
                                    color:
                                      emi?.type === selectedEmi?.type
                                        ? "#004F71"
                                        : "inherit",
                                    transition: "0.3s ease",
                                    border:
                                      emi?.type === selectedEmi?.type
                                        ? "1px solid #004F71"
                                        : "1px solid rgb(201, 201, 201)",
                                    "&:hover": {
                                      boxShadow: 3,
                                      backgroundColor:
                                        emi?.type === selectedEmi?.type
                                          ? "1px solid #004F71"
                                          : "#fff",
                                    },
                                  }}
                                >
                                  <Stack spacing={1}>
                                    <Typography variant="h6" fontWeight={600}>
                                      {emi?.name}
                                    </Typography>

                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      {/* Installments: */}
                                      <strong>
                                        {processingFee
                                          ? emi?.installment_with_fee
                                          : emi?.installment}
                                      </strong>
                                    </Typography>

                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      {/* Frequency:  */}
                                      {emi?.frequency}
                                    </Typography>

                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      {processingFee
                                        ? emi?.formatted_amount_with_fee
                                        : emi?.formatted_amount}{" "}
                                      × {emi.month}
                                      Months
                                      {/* =
                                      <strong>{emi.total_amount}</strong> */}
                                    </Typography>
                                  </Stack>
                                </Box>
                              </Grid>
                            </>
                          );
                        })}
                      </>
                    ) : null}
                    {/* <Grid
                      size={{ xs: 12, xl: 4, lg: 6, md: 6, sm: 6 }}
                      className={style.checkoutRadio}
                    >
                      <GlobalRadio title="$25,000 x 4 Months" />
                    </Grid> */}
                    <Grid size={{xs: 12}}>
                      {partialPayment ? (
                        <>
                          <Box className={style.partialPaymentText}>
                            <FormControl
                              component="fieldset"
                              variant="standard"
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={autoDebit}
                                    name="Auto Debit"
                                    onChange={() => setAutoDebit(!autoDebit)}
                                  />
                                }
                                label="Auto Debit"
                                disabled={!selectedEmi}
                              />
                            </FormControl>
                          </Box>
                        </>
                      ) : null}

                      <Box className={style.checkOutBtn}>
                        <Button
                          disabled={!processingFee && paymentId == 1}
                          variant="contained"
                          type="submit"
                        >
                          Pay Now
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </form>
              ) : (
                <form
                  onSubmit={chequeFormik.handleSubmit}
                  autoComplete="false"
                  autoSave="false"
                >
                  <Grid container spacing={2}>
                    {/* Check content div */}
                    <Grid size={{xs: 12, lg: 6, sm: 6}}>
                      <FormControl fullWidth>
                        <FormLabel
                          sx={{mb: 1, textAlign: "left", color: "#000000"}}
                        >
                          Cheque Number
                        </FormLabel>
                      </FormControl>
                      <GlobalTextField
                        type="text"
                        name="cheque_number"
                        id="_cheque_number"
                        value={chequeFormik.values.cheque_number}
                        onChange={chequeFormik.handleChange}
                        onBlur={chequeFormik.handleBlur}
                        error={
                          chequeFormik.touched.cheque_number &&
                          Boolean(chequeFormik.errors.cheque_number)
                        }
                        helperText={
                          chequeFormik.touched.cheque_number &&
                          chequeFormik.errors.cheque_number
                        }
                      />
                    </Grid>
                    <Grid size={{xs: 12, lg: 6, sm: 6}}>
                      <FormControl fullWidth>
                        <FormLabel
                          sx={{mb: 1, textAlign: "left", color: "#000000"}}
                        >
                          Amount
                        </FormLabel>
                      </FormControl>
                      <GlobalTextField
                        placeH={"$"}
                        name="amount"
                        id="_amount"
                        value={chequeFormik.values.amount}
                        onChange={(e) => {
                          // handleAmountFieldChange(e, "amount")
                        }}
                        onBlur={chequeFormik.handleBlur}
                        error={
                          chequeFormik.touched.amount &&
                          Boolean(chequeFormik.errors.amount)
                        }
                        helperText={
                          chequeFormik.touched.amount &&
                          chequeFormik.errors.amount
                        }
                        readOnly
                      />
                    </Grid>
                    <Grid
                      size={{xs: 12, lg: 6, sm: 6}}
                      sx={{mt: 1}}
                      className="choosefileBtn"
                    >
                      <p className={style.fileBtnp}> Front Of Cheque </p>

                      <div className={style.chequeImgBox}>
                        <Button
                          component="label"
                          role={undefined}
                          variant="contained"
                          tabIndex={-1}
                          startIcon={<CloudUploadIcon />}
                        >
                          {chequeFormik.values?.cheque_img_front
                            ? `Selected Image - ${chequeFormik.values?.cheque_img_front?.name}`
                            : "Upload Image"}
                          <VisuallyHiddenInput
                            type="file"
                            accept="image/*"
                            onChange={(event) =>
                              chequeFormik.setFieldValue(
                                "cheque_img_front",
                                event.target.files[0]
                              )
                            }
                            onBlur={() =>
                              chequeFormik.setFieldTouched(
                                "cheque_img_front",
                                true
                              )
                            }
                          />
                        </Button>
                        <div className={style.checkFormTitle}>
                          <span>
                            {chequeFormik.touched.cheque_img_front &&
                            chequeFormik.errors.cheque_img_front ? (
                              <GlobalErrorMsgBox
                                errMessage={
                                  chequeFormik.errors.cheque_img_front
                                }
                              />
                            ) : (
                              ""
                            )}
                          </span>
                          <ButtonGroup
                            disableElevation
                            variant="outlined"
                            aria-label="Disabled button group"
                          >
                            <Button
                              onClick={() =>
                                handleClickOpen("cheque_img_front")
                              }
                              className={style.checkOutDeleteView}
                            >
                              <FaEye />
                            </Button>
                            <Button
                              onClick={() =>
                                chequeFormik.setFieldValue(
                                  "cheque_img_front",
                                  ""
                                )
                              }
                              className={style.checkOutDeleteBtn}
                            >
                              <MdDeleteForever />
                            </Button>
                          </ButtonGroup>
                        </div>
                      </div>
                    </Grid>

                    <Grid
                      size={{xs: 12, lg: 6, sm: 6}}
                      sx={{mt: 1}}
                      className="choosefileBtn"
                    >
                      <p className={style.fileBtnp}> Back Of Cheque </p>
                      <div>
                        <Button
                          component="label"
                          role={undefined}
                          variant="contained"
                          tabIndex={-1}
                          startIcon={<CloudUploadIcon />}
                        >
                          {chequeFormik.values?.cheque_img_back
                            ? `Selected Image - ${chequeFormik.values?.cheque_img_back?.name}`
                            : "Upload Image"}

                          <VisuallyHiddenInput
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              chequeFormik.setFieldValue(
                                "cheque_img_back",
                                e.target.files[0]
                              )
                            }
                            onBlur={() =>
                              chequeFormik.setFieldTouched(
                                "cheque_img_back",
                                true
                              )
                            }
                          />
                        </Button>
                      </div>
                      <div className={style.checkFormTitle}>
                        <span>
                          {chequeFormik.touched.cheque_img_back &&
                          chequeFormik.errors.cheque_img_back ? (
                            <GlobalErrorMsgBox
                              errMessage={chequeFormik.errors.cheque_img_back}
                            />
                          ) : (
                            ""
                          )}
                        </span>
                        <ButtonGroup
                          disableElevation
                          variant="outlined"
                          aria-label="Disabled button group"
                        >
                          <Button
                            onClick={() => handleClickOpen("cheque_img_back")}
                            className={style.checkOutDeleteView}
                          >
                            <FaEye />
                          </Button>
                          <Button
                            onClick={() =>
                              chequeFormik.setFieldValue("cheque_img_back", "")
                            }
                            className={style.checkOutDeleteBtn}
                          >
                            <MdDeleteForever />
                          </Button>
                        </ButtonGroup>
                      </div>
                    </Grid>

                    <Box className={style.checkOutBtn}>
                      <Button type="submit" variant="contained">
                        Pay Now
                      </Button>
                    </Box>
                  </Grid>
                </form>
              )}
            </div>
          </Grid>
        </Grid>
      </section>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{m: 0, p: 2}} id="customized-dialog-title">
          Cheque Image
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid size={{xs: 12}}>
              <div className={style.chequeImgModal}>
                <img src={imagePopup?.img_preview} alt="cheque_img" />
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className={style.chequeModalBtn}>
          <Button
            variant="contained"
            onClick={() => handleCloseChequeImage(imagePopup?.type)}
          >
            <MdDeleteForever /> Remove
          </Button>
        </DialogActions>
      </BootstrapDialog>
      <GlobalModal
        open={paymentStatusModal}
        maxWidth="sm"
        // handleClose={() => {
        //   handlePaymentModalClose();
        // }}
        // title={""}
        dialogTitleClass={style.claimPopTitle}
        dialogContent={
          <Grid container spacing={2}>
            <>
              <Grid size={{xs: 12, md: 12}} sx={{textAlign: "center"}}>
                <div className={style.paymentDoneMain}>
                  {paymentStatusData?.status == 1 ? (
                    <>
                      <img src={PaymentSuccess} />
                      <h2>Payment Successful!</h2>
                      <p> Congratulations! 🎉 You've got covered.</p>
                      <p>
                        Reference Number : #
                        {paymentStatusData?.data?.reference_id}{" "}
                      </p>
                    </>
                  ) : (
                    <>
                      <img src={PaymentFail} />
                      <h3>Payment Failed!</h3>
                      <p>Uh-oh! 😟 Something went wrong.</p>
                      <p>We weren’t able to process your payment.</p>
                      {/* <p>Don’t worry—please try again.</p> */}
                      {/* <p>Please try again or contact support if the issue persists.</p> */}
                    </>
                  )}
                  <CountdownRedirect
                    seconds={12}
                    onComplete={() => {
                      handlePaymentModalClose();
                      navigate("/dashboard");
                    }}
                  />
                  <Button
                    variant="contained"
                    onClick={() => {
                      handlePaymentModalClose();
                      navigate("/dashboard");
                    }}
                  >
                    Back to Dashboard
                  </Button>
                </div>
              </Grid>
            </>
          </Grid>
        }
      />
    </>
  );
};

export default Checkout;
